<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol lg="3">
                <div class="form-group">
                  <label for="filterAgen">Seller</label>
                  <model-select
                    class="form-control"
                    id="filterAgen"
                    :options="agentList"
                    v-model="filter.agent"
                    placeholder="-- ALL --"
                  ></model-select>
                </div>
              </CCol>

              <CCol lg="3">
                <div class="form-group">
                  <label for="filterStatus">Status</label>
                  <model-select
                    class="form-control"
                    id="filterStatus"
                    :options="statusList"
                    v-model="filter.status"
                    placeholder="-- ALL --"
                  ></model-select>
                </div>
              </CCol>

              <CCol lg="3">
                <div class="form-group">
                  <label for="date_order">Date Order</label>
                  <vc-date-picker
                    id="date_order"
                    :input-props="{
                      class: 'form-control is-valid',
                      placeholder: 'Date Order',
                    }"
                    :popover="{ placement: 'top-start' }"
                    v-model="filter.date_order"
                    :is-required="true"
                  ></vc-date-picker>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12">
                <br />
                <CButton size="sm" @click="searching" color="info">
                  <i class="fa fa-search"></i>
                  Filter
                </CButton>
                &nbsp;
                <CButton size="sm" @click="clearFilter" color="danger">
                  <i class="fa fa-undo"></i>
                  Clear
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columngroups="fieldsgroup"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :localization="localization"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <template v-if="!loadingAdd">
          <CRow>
            <CCol sm="3">
              <div class="form-group">
                <label for="agent_code">Seller Code</label>
                <model-select
                  class="form-control"
                  id="agent_code"
                  :options="agentList"
                  v-model="$v.orderForm.agent_code.$model"
                  :isError="$v.orderForm.agent_code.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                  @input="filterCustomer"
                ></model-select>
                <div
                  v-if="$v.orderForm.agent_code.$invalid"
                  class="invalid-feedback-custom"
                >
                  Seller should be filled.
                </div>
              </div>
            </CCol>
            <CCol sm="3">
              <div class="form-group">
                <label for="user_code">Customer</label>
                <model-select
                  class="form-control"
                  id="user_code"
                  :options="userList"
                  v-model="$v.orderForm.user_code.$model"
                  :isError="$v.orderForm.user_code.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.orderForm.user_code.$invalid"
                  class="invalid-feedback-custom"
                >
                  Users should be filled.
                </div>
              </div>
            </CCol>
            <CCol sm="3">
              <div class="form-group">
                <label for="delivery">Delivery</label>
                <model-select
                  class="form-control"
                  id="delivery"
                  :options="deliveryList"
                  v-model="$v.orderForm.delivery.$model"
                  :isError="$v.orderForm.delivery.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                  @input="filterDeliveryType"
                ></model-select>
                <div
                  v-if="$v.orderForm.delivery.$invalid"
                  class="invalid-feedback-custom"
                >
                  Delivery should be filled.
                </div>
              </div>
            </CCol>
            <CCol sm="3">
              <div class="form-group">
                <label for="delivery_type">Delivery Type</label>
                <model-select
                  class="form-control"
                  id="delivery_type"
                  :options="deliveryTypeList"
                  v-model="$v.orderForm.delivery_type.$model"
                  :isError="$v.orderForm.delivery_type.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.orderForm.delivery_type.$invalid"
                  class="invalid-feedback-custom"
                >
                  Delivery Type should be filled.
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="3">
              <div class="form-group">
                <label for="delivery_time">Delivery Time</label>
                <VueCtkDateTimePicker
                  :id="'delivery_time'"
                  :locale="'ID'"
                  :error="orderForm.delivery_time === null ? true : false"
                  v-model="orderForm.delivery_time"
                  :no-label="true"
                  :no-button-now="true"
                  :format="'YYYY-MM-DD hh:mm'"
                />
                <div
                  v-if="orderForm.delivery_time === null ? true : false"
                  class="invalid-feedback-custom"
                >
                  Delivery Time should be filled.
                </div>
              </div>
            </CCol>
            <CCol sm="3">
              <div class="form-group">
                <label for="date_order">Date Order</label>
                <vc-date-picker
                  id="date_order"
                  :input-props="{
                    class: !$v.orderForm.date_order.$invalid
                      ? 'form-control is-valid'
                      : 'form-control is-invalid',
                    placeholder: 'Date Order',
                  }"
                  :popover="{ placement: 'top-start' }"
                  :state="!$v.orderForm.date_order.$invalid"
                  v-model="$v.orderForm.date_order.$model"
                  :is-required="true"
                ></vc-date-picker>
                <div
                  v-if="$v.orderForm.date_order.$invalid"
                  class="invalid-feedback-custom"
                >
                  Date order should be filled.
                </div>
              </div>
            </CCol>
            <CCol sm="6">
              <CTextarea
                rows="4"
                label="Notes"
                invalid-feedback="Notes should be filled"
                v-model="$v.orderForm.notes.$model"
                :is-valid="!$v.orderForm.notes.$invalid"
              />
            </CCol>
          </CRow>
        </template>
        <loading v-else></loading>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.orderForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

export default {
  name: "Order",
  components: {
    VueCtkDateTimePicker,
    Loading,
    JqxGrid,
    TableButton,
  },
  data() {
    return {
      title: "Order",
      userList: [],
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "order_number", type: "string" },
          { name: "user_code", type: "string" },
          { name: "agent_code", type: "string" },
          { name: "payment_method_name", type: "string" },
          { name: "user_name", type: "string" },
          { name: "date_order", type: "date" },
          { name: "status_name", type: "string" },
          { name: "delivery_name", type: "string" },
          { name: "type_delivery_name", type: "string" },
          { name: "delivery_address", type: "string" },
          { name: "total_order", type: "float" },
          { name: "delivery_price", type: "float" },
          { name: "voucher_price", type: "float" },
          { name: "sub_total", type: "float" },
        ],
        datatype: "json",
      },
      editrow: -1,
      fields: [
        {
          datafield: "order_number",
          columntype: "textbox",
          filtertype: "textbox",
          text: "No. Order",
        },
        {
          datafield: "user_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Kode User",
          hidden: true,
        },
        {
          datafield: "delivery_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama Pengiriman",
          hidden: true,
        },
        {
          datafield: "type_delivery_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Tipe Pengiriman",
          hidden: true,
        },
         {
          datafield: "delivery_address",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Alamat",
          hidden: true,
        },
        {
          datafield: "user_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama User",
        },
        {
          datafield: "agent_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Seller",
        },
        {
          datafield: "payment_method_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Metode Pembayaran",
        },
        {
          datafield: "date_order",
          columntype: "datetimeinput",
          filtertype: "date",
          text: "Tanggal Order",
          cellsformat: "d",
          cellsalign: "right",
        },
        {
          datafield: "status_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Status",
        },
        {
          datafield: "total_order",
          columntype: "numberinput",
          columngroup: "ActionsGroup",

          filtertype: "textbox",
          text: "Subtotal",
          cellsformat: "c2",
          align: "right",
          cellsalign: "right",
        },
        {
          datafield: "delivery_price",
          columntype: "numberinput",
          columngroup: "ActionsGroup",

          filtertype: "textbox",
          text: "Biaya Pengiriman",
          cellsformat: "c2",
          align: "right",
          cellsalign: "right",
        },
        {
          datafield: "voucher_price",
          columntype: "numberinput",
          columngroup: "ActionsGroup",

          filtertype: "textbox",
          text: "Voucher",
          cellsformat: "c2",
          align: "right",
          cellsalign: "right",
        },
        {
          datafield: "sub_total",
          columntype: "numberinput",
          columngroup: "ActionsGroup",

          filtertype: "textbox",
          text: "Total Order",
          cellsformat: "c2",
          align: "right",
          cellsalign: "right",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],

      fieldsgroup: [
        {
          text: "Total",
          align: "center",
          name: "ActionsGroup",
        },
      ],

      listBoxSource: [
        {
          label: "Kode User",
          value: "user_code",
          checked: false,
        },
        {
          label: "Nama Pengiriman",
          value: "delivery_name",
          checked: false,
        },
        {
          label: "Tipe Pengiriman",
          value: "type_delivery_name",
          checked: false,
        },
        {
          label: "Alamat Pengiriman",
          value: "delivery_address",
          checked: false,
        },
      ],

      items: null,
      agentList: [],
      statusList: [],
      deliveryList: [],
      deliveryTypeList: [],
      paymentMethodList: [],
      orderStatusList: [],
      orderForm: tableInterfaces.order,
      isLoading: false,
      addButton: false,
      loadingAdd: false,
      isEdit: false,
      filter: {
        agent: null,
        status: null,
        date_order: null,
      },
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    orderForm: {
      user_code: { required },
      agent_code: { required },
      delivery: { required },
      delivery_type: { required },
      date_order: { required },
      delivery_time: { required },
      notes: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    is_agent: function () {
      const agent = localStorage.getItem("is_agent");
      return agent === "true" ? true : false;
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.resetForm();
      this.cancelForm();
      this.getDropdown();
      this.getOrder();
    },
    getOrder: function (filtering = {}) {
      this.isLoading = true;
      this.axios
        .post("console/order/listing", filtering)
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDropdown: function () {
      this.axios.get("/console/dropdown/order").then((response) => {
        this.statusList = response.data.order_status;
        this.agentList = response.data.agent;
        this.orderStatusList = response.data.order_status;
      });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      // console.log(item);
      this.addForm();
      this.isEdit = true;
      this.orderForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.order) {
        tableInterfaces.order[i] = null;
      }
      this.orderForm = tableInterfaces.order;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Do you want to add this data ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/order/add", this.orderForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
            this.$router.push({
              path: path[2] + "/detail/" + response.data.id,
            });
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    searching: function () {
      this.getOrder(this.filter);
    },
    clearFilter: function () {
      this.filter = {
        agent: null,
        status: null,
        date_order: null,
      };
      this.getOrder(this.filter);
    },
    filterCustomer: function () {
      this.orderForm.user_code = null;
      this.orderForm.delivery = null;
      this.orderForm.delivery_type = null;
      this.userList = [];
      this.deliveryList = [];
      this.deliveryTypeList = [];
      this.loadingAdd = true;
      this.axios
        .get("/console/dropdown/user-based-on-agent/" + this.orderForm.agent_code)
        .then((response) => {
          this.userList = response.data.users;
          this.deliveryList = response.data.delivery;
        })
        .finally(() => {
          this.loadingAdd = false;
        });
    },
    filterDeliveryType: function () {
      this.orderForm.delivery_type = null;
      this.deliveryTypeList = [];
      this.axios
        .get("/console/dropdown/delivery-type/" + this.orderForm.delivery)
        .then((response) => {
          this.deliveryTypeList = response.data.data;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
